import { Routes, Route } from 'react-router-dom';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './paginas/login';
import Painel from './paginas/painel';
import UserPainel from './paginas/user_painel';
import VisualizarCarteirasPublic from './paginas/visualizarCarteiras';
import Principal from './paginas/principal';
import Gestores from './paginas/Gestores';
import Consulta from './paginas/consulta/consulta';
import CriarCarteiraVendedor from './paginas/CriarCarteiraVendedor';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './componentes/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{ zIndex: 10001 }}
      />
      <Routes>
        <Route path="/" element={<Principal />} />
        <Route path="/login" element={<Login />} />
        <Route path="/consulta" element={<Consulta />} />
        <Route path="/painel" element={<ProtectedRoute><Painel /></ProtectedRoute>} />
        <Route path="/user/:id" element={<ProtectedRoute><UserPainel /></ProtectedRoute>} />
        <Route path="/carteiras/:id" element={<VisualizarCarteirasPublic />} />
        <Route path="/carteiras/editar/:id" element={<ProtectedRoute></ProtectedRoute>} />
        <Route path="/gestores" element={<ProtectedRoute roles={['administrador']}><Gestores /></ProtectedRoute>} />
        <Route path="/criar-carteira/:token" element={<CriarCarteiraVendedor />} />
        <Route path="/criar-carteira" element={<CriarCarteiraVendedor />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;